"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var link_1 = tslib_1.__importDefault(require("next/link"));
var react_1 = tslib_1.__importDefault(require("react"));
var Link = function (_a) {
    var to = _a.to, children = _a.children, props = tslib_1.__rest(_a, ["to", "children"]);
    if (to.startsWith("/")) {
        return (react_1["default"].createElement(link_1["default"], { href: to, passHref: true },
            react_1["default"].createElement("a", tslib_1.__assign({}, props), children)));
    }
    return (react_1["default"].createElement("a", tslib_1.__assign({}, props, { href: to, target: "_blank", rel: "noopener noreferrer" }), children));
};
exports["default"] = Link;
//# sourceMappingURL=Link.js.map